export type CustomerSmsTemplate = {
  key: string;
  label: string;
  bodyText: string;
};

export const customerSmsTemplates: CustomerSmsTemplate[] = [
  {
    key: "appointment_follow_up",
    label: "Appointment follow-up",
    bodyText: "Hi {{ customer.firstName }}, quick question about your cleaning appointment. Please reply when you have a moment."
  },
  {
    key: "access_instructions",
    label: "Access instructions",
    bodyText: "Hi {{ customer.firstName }}, could you please confirm the entry/access instructions for your cleaning appointment?"
  },
  {
    key: "arrival_update",
    label: "Arrival update",
    bodyText: "Hi {{ customer.firstName }}, we have an update about your arrival window. Please reply when you have a moment."
  },
  {
    key: "payment_follow_up",
    label: "Payment follow-up",
    bodyText: "Hi {{ customer.firstName }}, we have a quick question about your booking balance. Please reply when convenient."
  },
  {
    key: "general_check_in",
    label: "General check-in",
    bodyText: "Hi {{ customer.firstName }}, this is a quick follow-up about your cleaning service. Please reply when you have a moment."
  }
];

export function getCustomerSmsTemplate(key: string) {
  return customerSmsTemplates.find((template) => template.key === key) ?? null;
}
